import AppIcon from "./AppIcon";
import clx from "classnames";

export default function Spinner({ className = "w-4 h-4 text-gray-300" }) {
  return <AppIcon code="fa-spinner" className={clx(className, "animate-spin")} />;
}
